import { SlidersHorizontal } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function SettingsSystemPage() {
  return (
    <Card className="border-border/50">
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 mb-4">
          <SlidersHorizontal className="h-6 w-6 text-primary" />
        </div>
        <h2 className="text-lg font-semibold mb-1">System Settings</h2>
        <p className="text-sm text-muted-foreground max-w-sm">
          System configuration options will be available here soon.
        </p>
      </CardContent>
    </Card>
  );
}
